module.exports = __webpack_public_path__ + "logo-black.508f8d0795395f8757acdb0bbdedaaff.svg";